export default {"src":"/_next/static/media/track-and-field.c607c461.svg","height":55,"width":55,"blurWidth":0,"blurHeight":0};